import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNumber = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8.674 2.855a.75.75 0 0 1 .55.907L6.182 16.179a.75.75 0 1 1-1.457-.357L7.767 3.405a.75.75 0 0 1 .907-.55m6.083 0a.75.75 0 0 1 .55.907l-3.041 12.417a.75.75 0 1 1-1.457-.357L13.85 3.405a.75.75 0 0 1 .907-.55"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M18.123 6.847a.78.78 0 0 1-.767.757l-13.48.025a.72.72 0 0 1-.72-.754.78.78 0 0 1 .767-.757l13.48-.025a.72.72 0 0 1 .72.754m-1.399 5.851a.78.78 0 0 1-.768.757l-13.48.025a.72.72 0 0 1-.72-.754.78.78 0 0 1 .768-.757l13.48-.025a.72.72 0 0 1 .72.754"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNumber;
